const isTeacher = (user: any) => {
  if (user?.roles?.includes('user') && user?.groupPermission?.name === 'Teachers') {
    return true;
  }
  return false;
};

export default isTeacher;
